import { HEADERS } from "../actionTypes";
const initialState = {
    notiicationList: [],
    userInfo: {},
    userPreference: [],
    savedUserPreference: [],
    objProfilePicture: {},
    showLoader: true,
    showError: false,
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
    tenantUserPreference: {}
    //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End
};

const notificationsReducer = (state = initialState, action) => {
    switch (action.type) {

        case HEADERS.GET_NOTIFICATIONS:
            return {
                ...state,
                noticationList: [
                    {
                        id: 1,
                        content: 'Usage Guide',
                    },
                    {
                        id: 2,
                        content: "Privacy Policy",
                    },
                    {
                        id: 3,
                        content: 'Terms of Use',
                    },
                    {
                        id: 4,
                        content: 'keyboard Shortcuts',
                    },
                    {
                        id: 5,
                        content: "Walkthrough",
                    },
                    {
                        id: 6,
                        content: 'About Us',
                    },
                    {
                        id: 7,
                        content: 'Contact Us',
                    },
                    {
                        id: 8,
                        content: ' Divide',
                    },
                    {
                        id: 9,
                        content: ' Having problem? Share with us',
                    }
                ]
            };

        case HEADERS.GET_USERINFORMATION:
            return {
                ...state,
                userInfo: {
                    id: 1,
                    username: 'Nameet',
                    Lastlogin: "09:48 AM 02/12/2022",
                    activeusers: [
                        {
                            name: "sushant",
                            status: "active"
                        },
                        {
                            name: "karan",
                            status: "inactive"
                        },

                    ]
                }
            };
        case HEADERS.GET_USER_PREFERENCE_DATA:
            return {
                ...state,
                userPreference: action.payload,
            };
        case HEADERS.GET_USER_PREFERENCE_SUCCESS:
            return {
                ...state,
                userPreference: action.payload,
                savedUserPreference: action.payload,
                showLoader: false,
                showError: false
            };
        case HEADERS.GET_USER_PREFERENCE_FAILURE:
            return {
                ...state,
                // userPreference: action.payload,
                showError: true,
                showLoader: false

            };
            case HEADERS.RESET_USER_PREFERENCE:
                return {
                    ...state,
                    userPreference: state.savedUserPreference,
    
                };
        case HEADERS.UPLOAD_USER_PROFILE_PICTURE_SUCCESS:
            return {
                ...state,
                objProfilePicture: action.payload
            };
        case HEADERS.UPLOAD_USER_PROFILE_PICTURE_FAILURE:
            return {
                ...state,
                objProfilePicture: action.payload
            };
        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
        case HEADERS.UPDATE_TENANT_USER_PREFERENCE:
            return {
                ...state,
                tenantUserPreference: action.payload
            };
        //Prachi T - 16-11-2023 - BT-110050 - Breeze- Settings Preferences - End

        /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number -Start */
        case HEADERS.SEGMENT_WISE_VERSION_SUCCESS:
        case HEADERS.SEGMENT_WISE_VERSION_FAILURE:
            return {
                ...state,
                segmentVersionNo:action.payload
            } 
        /* BREEZE-4265 : Ravi R : 05-03-2025: Display segment wise version number -End */



        default: return state;
    }
};

export default notificationsReducer;